var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCertif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5861 28.162C36.713 25.7065 38 22.5036 38 19C38 11.268 31.732 5 24 5C16.268 5 10 11.268 10 19C10 22.3458 11.1736 25.4174 13.1317 27.8257L11.0759 38.2242C10.7926 39.6575 11.3132 41.1313 12.434 42.0685C13.5548 43.0058 15.0975 43.2574 16.458 42.7248L24.0154 39.7667L31.542 42.7128C32.9099 43.2482 34.4611 42.9908 35.5828 42.0423C36.7044 41.0939 37.216 39.6069 36.9153 38.1691L34.7757 27.9384C34.7133 28.0136 34.65 28.0881 34.5861 28.162ZM34 19C34 24.5228 29.5228 29 24 29C18.4772 29 14 24.5228 14 19C14 13.4772 18.4772 9 24 9C29.5228 9 34 13.4772 34 19ZM31.3166 30.9383C29.1874 32.246 26.6818 33 24 33C21.2846 33 18.7497 32.2269 16.6035 30.8889L15 39L23.0455 35.8508C23.6699 35.6064 24.3609 35.6064 24.9853 35.8508L33 38.988L31.3166 30.9383Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertif);
export default __webpack_public_path__ + "static/media/icon-certif.58e5fca2b77067fa54ffe44c9dbbf073.svg";
export { ForwardRef as ReactComponent };